import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'DFD'

const GetAll = (company, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/empresa/${company}`, data, config)

export default {
  GetAll
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/dfd.js